import { View, ActivityIndicator } from "react-native";
import { useActiveAgent } from "../../../../contexts/ActiveAgentContext";
import StyledText from "../../../common/ui/styled-text";
import LomanRobot from "../../../common/loman-robot";

const ActivateLomanButton = ({ onClick }: { onClick: () => void }) => {
  const { isLoadingAgentStatus: isLoading } = useActiveAgent();
  return (
    <button
      onClick={onClick}
      className="shimmer-button grid grid-cols-1 grid-rows-1 max-w-96"
    >
      <View
        className={`col-start-1 row-start-1 flex flex-row items-center gap-2 justify-center ${
          isLoading ? "opacity-0" : "opacity-100"
        }`}
      >
        <StyledText className="text-sm font-medium text-white">
          Activate Loman
        </StyledText>

        <LomanRobot size={20} color="white" />
      </View>

      <View
        className={`col-start-1 row-start-1 ${
          isLoading ? "visible" : "hidden"
        }`}
      >
        <ActivityIndicator size="small" color="#fff" />
      </View>
    </button>
  );
};

export default ActivateLomanButton;
